import { render, staticRenderFns } from "./RtcMismatch.vue?vue&type=template&id=2fb7d483&"
import script from "./RtcMismatch.vue?vue&type=script&lang=js&"
export * from "./RtcMismatch.vue?vue&type=script&lang=js&"
import style0 from "./RtcMismatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports